package one.healthium.onboarding.utils

import androidx.compose.runtime.Composable

@Composable
actual fun NotificationPermissionRequester(content: @Composable ((suspend () -> Unit) -> Unit)) {
    content({ })
}